// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "https://dev-static.skin-seoul.com";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/brand/:brandName\",\"regex\":\"^/brand/([^/]+)$\",\"paramNames\":[\"brandName\"]},{\"path\":\"/collections/:slug*\",\"regex\":\"^/collections/(.+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/product/:slug\",\"regex\":\"^/product/([^/]+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/product-tag/:tagSlug\",\"regex\":\"^/product-tag/([^/]+)$\",\"paramNames\":[\"tagSlug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about-us\"},{\"path\":\"/checkout\"},{\"path\":\"/collections/skinseoulselects\"},{\"path\":\"/contact-us\"},{\"path\":\"/delivery-tracking\"},{\"path\":\"/my-account/loyalty\"},{\"path\":\"/return-refund-exchange-policy\"},{\"path\":\"/search\"},{\"path\":\"/shipping\"},{\"path\":\"/shop\"},{\"path\":\"/trends\"}]}";import * as Sentry from '@sentry/nextjs';
import { WEBAPP_IGNORE_ERRORS, beforeSend } from '@skin-seoul/service';
import structuredClone from '@ungap/structured-clone';

if (typeof globalThis.structuredClone === 'undefined') {
  globalThis.structuredClone = structuredClone as any;
}

const HOSTNAME = window.location.hostname;

const getEnviroment = () => {
  switch (HOSTNAME) {
    case 'dev.skin-seoul.com':
    case 'dev-webapp.skin-seoul.com':
      return 'DEV';
    case 'staging.skin-seoul.com':
    case 'staging-webapp.skin-seoul.com':
      return 'STAGING';
    case 'skin-seoul.com':
    case 'webapp.skin-seoul.com':
      return 'PROD';
    default:
      return 'LOCAL';
  }
};

Sentry.init({
  dsn: 'https://95769be57f2d0a4e5fbaad2add00318e@o4509507725230080.ingest.us.sentry.io/4509507733684224',
  enabled: getEnviroment() === 'PROD' || getEnviroment() === 'STAGING',
  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],
  beforeSend,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: getEnviroment() === 'PROD' ? 0.1 : 1.0,
  environment: getEnviroment(),

  // Define how likely Replay events are sampled.

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Ignore specific errors
  ignoreErrors: WEBAPP_IGNORE_ERRORS,

  // Enable Sentry Logs
  enableLogs: true,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
